export default __webpack_public_path__ + "static/media/ASD_logo.bc6a114d.webp";